// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer-canvas-container canvas {
    font-smooth: always;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* Editor wrapper */
.editor-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    background-color: #f3f4f6;
    min-height: 100vh;
    position: relative; /* Establish stacking context */
    z-index: 1; /* Baseline z-index */
}

/* Toolbar */
.toolbar {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: max-height 0.3s ease, background-color 0.3s ease, opacity 0.3s ease;
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%; /* Ensure full width */
    box-sizing: border-box; /* Include padding in width calculation */
    overflow-x: auto; /* Allow horizontal scrolling if needed */
}

.toolbar.popup-open {
    background-color: #f3f4f6; /* Neutral background */
    opacity: 0; /* Visually indicate it's disabled */
    z-index: 10; /* Lower z-index when popup is open */
    position: absolute; /* Change to absolute to break sticky context */
    pointer-events: none; /* Disable interaction when popup is open */
    width: 100%; /* Ensure full width */
    top: 0;
}

.toolbar-collapsed {
    max-height: 4.5rem;
}

.sticky {
    position: sticky;
    top: 0;
    z-index: 100;
}

.tools-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap; /* Allow wrapping to prevent overflow */
    gap: 0.5rem; /* Reduced gap for better mobile fit */
    justify-content: center;
    min-width: 0; /* Prevent overflow in flex container */
}

.font-tools {
    display: flex;
    align-items: center;
    gap: 0.5rem; /* Reduced gap for mobile */
}

.tools-group:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 0.5rem;
}

.tool-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    height: 56px; /* Reduced height for mobile */
    min-width: 48px; /* Ensure minimum width for touch targets */
    flex-shrink: 0; /* Prevent shrinking too much */
}

.tool-label {
    font-size: 0.65rem; /* Slightly smaller font for mobile */
    color: #6b7280;
    margin-top: 2px;
}

.tool-button {
    height: 32px; /* Reduced size for mobile */
    width: 32px;
    padding: 0.3rem;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 0.375rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.toolbar.popup-open .tool-button {
    background: #f3f4f6; /* Match toolbar background when popup is open */
}

.tool-button:hover {
    background-color: #f3f4f6;
}

.tool-button.active {
    background-color: #e5e7eb;
}

.tool-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Editing mode toggle button styles */
.mode-toggle {
    margin-right: 6px;
}

.mode-button {
    border: 2px solid;
    border-color: #e5e7eb;
    transition: all 0.2s ease;
}

.mode-button.mode-active {
    background-color: #4f46e5;
    color: white;
    border-color: #4f46e5;
}

.mode-button.mode-active:hover {
    background-color: #4338ca;
    border-color: #4338ca;
}

.mode-button:not(.mode-active):hover {
    border-color: #d1d5db;
    background-color: #f9fafb;
}

/* Canvas container */
.outer-canvas-container {
    display: flex;
    background-color: #f3f4f6;
    border-radius: 0.5rem;
    overflow: auto;
    max-width: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 1rem;
    z-index: 1;
}

.outer-canvas-container.view-mode {
    cursor: default;
}

.outer-canvas-container.view-mode canvas {
    cursor: default;
}

/* New responsive canvas styles */
.canvas-container {
    border: 5px solid #2DAA9E;
    border-radius: 2px;
    max-width: 100%;
    overflow: auto;
}

canvas {
    max-width: 100%;
    height: auto !important;
}

/* Tool select and color */
.tool-select {
    height: 32px; /* Reduced height for mobile */
    padding: 0.2rem 0.5rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    outline: none;
    min-width: 100px; /* Adjusted for mobile */
    font-size: 0.9rem; /* Smaller font for mobile */
    background: white;
    color: #374151;
    transition: border-color 0.3s ease;
}

.tool-select:focus {
    border-color: #2DAA9E;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);
}

/* Tool color */
.tool-color {
    padding: 0;
    width: 32px; /* Reduced size for mobile */
    height: 32px;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    cursor: pointer;
}

/* Font size control */
.font-size-control {
    display: flex;
    align-items: center;
    height: 32px; /* Reduced height for mobile */
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    overflow: hidden;
}

.font-size-control .tool-button {
    height: 100%;
    width: 24px; /* Reduced width for mobile */
    border: none;
    border-radius: 0;
}

.font-size-display {
    min-width: 1.8rem; /* Adjusted for mobile */
    text-align: center;
    padding: 0 0.3rem;
    font-size: 0.85rem; /* Smaller font for mobile */
}

/* Hidden elements */
.hidden {
    display: none;
}

/* Context menu */
.context-menu {
    position: absolute;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.context-menu-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    width: 100%;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: background-color 0.2s;
    white-space: nowrap;
}

.context-menu-item:hover {
    background-color: #f3f4f6;
}

/* Dropdown menus */
.shapes-dropdown,
.download-dropdown,
.layers-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 200;
    min-width: 160px; /* Reduced for mobile */
    padding: 6px 0; /* Adjusted padding */
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 6px; /* Reduced gap for mobile */
    padding: 6px 12px; /* Adjusted padding */
    width: 100%;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
    font-size: 0.9rem; /* Smaller font for mobile */
    color: #374151;
    white-space: nowrap;
}

.dropdown-item:hover {
    background: #f3f4f6;
}

/* Utility classes */
.relative {
    position: relative;
}

.text-red-500 {
    color: #ef4444;
}

.ml-1 {
    margin-left: 0.25rem;
}

/* Loading fonts */
.loading-fonts {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    gap: 1rem;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-top-color: #2DAA9E;
    animation: spin 1s linear infinite;
}

/* Popup styles */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
    pointer-events: auto;
}

.popup-content {
    background-color: var(--white);
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    max-width: 700px;
    width: 95%;
    max-height: 80vh;
    overflow-y: auto;
    z-index: 100001;
    pointer-events: auto;
}

.popup-header {
    padding: 1rem 1.5rem;
    background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
    color: var(--white);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}

.popup-header h3 {
    margin: 0;
    font-size: 1.25rem; /* Reduced for mobile */
    font-weight: 600;
}

.popup-body {
    padding: 1rem; /* Adjusted padding for mobile */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.popup-footer {
    display: flex;
    justify-content: center;
    gap: 0.75rem; /* Reduced gap for mobile */
    padding: 0.75rem 1rem; /* Adjusted padding */
    border-top: 1px solid #e5e7eb;
}

.popup-button {
    padding: 0.5rem 1rem; /* Adjusted for mobile */
    border: none;
    border-radius: 0.5rem;
    font-size: 0.875rem; /* Smaller font for mobile */
    min-width: 100px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.popup-button-primary {
    background-color: var(--secondary);
    color: var(--white);
}

.popup-button-primary:hover {
    background-color: #45b369;
    transform: translateY(-2px);
}

.popup-button-primary:disabled {
    background-color: #6b7280;
    cursor: not-allowed;
}

.popup-button-secondary {
    background-color: #e5e7eb;
    color: #374151;
}

.popup-button-secondary:hover {
    background-color: #d1d5db;
    transform: translateY(-2px);
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Adjusted for mobile */
    gap: 0.75rem; /* Reduced gap */
    padding: 0.75rem 0; /* Adjusted padding */
    width: 100%;
    box-sizing: border-box;
}

.image-option-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.image-option {
    width: 100%;
    height: 100px; /* Reduced height for mobile */
    object-fit: cover;
    cursor: pointer;
    border: 2px solid transparent;
}

.image-option-wrapper:hover .image-option {
    border-color: var(--primary);
}

.image-option-wrapper:hover {
    transform: scale(1.05);
}

.no-images,
.loading {
    text-align: center;
    color: #6b7280;
    font-size: 0.875rem; /* Smaller font for mobile */
    padding: 0.75rem;
}

.prompt-textarea {
    width: 100%;
    min-height: 80px; /* Reduced height for mobile */
    padding: 0.5rem; /* Adjusted padding */
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem; /* Smaller font for mobile */
    resize: vertical;
    transition: border-color 0.3s ease;
    margin-bottom: 0.75rem; /* Reduced margin */
}

.prompt-textarea:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);
}

.search-input-container {
    display: flex;
    gap: 8px; /* Reduced gap for mobile */
    margin-bottom: 15px; /* Adjusted margin */
}

.search-input {
    flex: 1 1;
    padding: 6px; /* Adjusted padding */
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.875rem; /* Smaller font for mobile */
}

/* Advanced Options Section */
.advanced-options {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.advanced-options-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    padding: 0.5rem 0;
    color: var(--light);
    font-size: 0.875rem; /* Smaller font for mobile */
    font-weight: 500;
}

.advanced-options-header:hover {
    /* Changed color to hide the button on the frontend */
    color: var(--light);
}

.triangle-icon {
    width: 0;
    height: 0;
    border-left: 5px solid transparent; /* Adjusted size for mobile */
    border-right: 5px solid transparent;
    /* Changed color to hide the button on the frontend */
    border-top: 5px solid var(--light);
    transition: transform 0.3s ease;
}

.advanced-options-header:hover .triangle-icon {
    /* Changed color to hide the button on the frontend */
    border-top-color: var(--light);
}

.advanced-options-header.open .triangle-icon {
    transform: rotate(180deg);
    /* Changed color to hide the button on the frontend */
    border-top-color: #2DAA9E;
}

.advanced-options-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.advanced-options-content.open {
    max-height: 180px; /* Adjusted for mobile */
}

/* GenAI Model Selector */
.genai-model-selector {
    margin-top: 0.5rem; /* Reduced margin */
    display: flex;
    flex-direction: column;
    gap: 0.4rem; /* Reduced gap */
    width: 100%;
}

.genai-model-selector label {
    font-size: 0.875rem; /* Smaller font for mobile */
    color: #374151;
    font-weight: 500;
    align-self: flex-start;
}

.genai-model-selector .tool-select {
    width: 100%;
    font-size: 0.875rem; /* Smaller font for mobile */
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    background: white;
    transition: border-color 0.3s ease;
    min-width: 200px; /* Adjusted for mobile */
    white-space: nowrap;
}

.genai-model-selector .tool-select:focus {
    border-color: #2DAA9E;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);
}

/* Ensure select options have visible text */
.genai-model-selector .tool-select option {
    font-size: 0.875rem; /* Smaller font for mobile */
    color: #374151;
    white-space: nowrap;
}

/* Animation */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .toolbar {
        padding: 0.5rem;
        overflow-x: auto; /* Enable horizontal scrolling */
        white-space: nowrap; /* Prevent wrapping unless explicitly allowed */
    }

    .toolbar-collapsed {
        max-height: 4rem;
    }

    .tools-group {
        flex-wrap: wrap; /* Allow wrapping */
        justify-content: flex-start;
        gap: 0.4rem; /* Further reduced gap */
        min-width: 0;
    }

    .tool-select {
        width: 100%;
        max-width: 160px; /* Adjusted for mobile */
        min-width: 90px;
        font-size: 0.85rem;
    }

    .font-size-control {
        width: 100%;
        max-width: 90px; /* Adjusted for mobile */
        height: 30px;
    }

    .font-size-control .tool-button {
        width: 22px; /* Further reduced */
    }

    .font-size-display {
        font-size: 0.8rem;
    }

    .tool-button {
        height: 30px; /* Further reduced */
        width: 30px;
        padding: 0.25rem;
    }

    .tool-item {
        height: 52px; /* Further reduced */
        min-width: 44px; /* Adjusted touch target */
    }

    .tool-label {
        font-size: 0.6rem; /* Further reduced */
    }

    .outer-canvas-container {
        width: 100%;
        overflow-x: auto;
    }

    canvas#canvas {
        transform-origin: top left;
        margin: 0 auto;
    }

    .popup-content {
        width: 95%;
        max-height: 90vh;
    }

    .popup-header h3 {
        font-size: 1.1rem; /* Further reduced */
    }

    .popup-button {
        padding: 0.4rem 0.8rem;
        font-size: 0.8rem;
        min-width: 90px;
    }

    .image-grid {
        grid-template-columns: repeat(auto-fit, minmax(90px, 1fr)); /* Adjusted for mobile */
        gap: 0.5rem;
    }

    .image-option {
        height: 90px; /* Further reduced */
    }

    .shapes-dropdown,
    .download-dropdown,
    .layers-dropdown {
        min-width: 140px; /* Further reduced */
        padding: 4px 0;
    }

    .dropdown-item {
        padding: 5px 10px;
        font-size: 0.85rem;
    }

    .genai-model-selector .tool-select {
        min-width: 180px; /* Adjusted for mobile */
        font-size: 0.85rem;
    }
}

@media (max-width: 480px) {
    .toolbar {
        padding: 0.4rem;
    }

    .tools-group {
        gap: 0.3rem;
    }

    .tool-item {
        height: 48px;
        min-width: 40px;
    }

    .tool-button {
        height: 28px;
        width: 28px;
        padding: 0.2rem;
    }

    .tool-label {
        font-size: 0.55rem;
    }

    .tool-select {
        max-width: 140px;
        font-size: 0.8rem;
    }

    .font-size-control {
        max-width: 80px;
        height: 28px;
    }

    .font-size-control .tool-button {
        width: 20px;
    }

    .font-size-display {
        font-size: 0.75rem;
    }

    .popup-header h3 {
        font-size: 1rem;
    }

    .popup-button {
        padding: 0.3rem 0.7rem;
        font-size: 0.75rem;
        min-width: 80px;
    }

    .image-grid {
        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
        gap: 0.4rem;
    }

    .image-option {
        height: 80px;
    }

    .prompt-textarea {
        min-height: 70px;
        font-size: 0.8rem;
    }

    .genai-model-selector .tool-select {
        min-width: 160px;
        font-size: 0.8rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/EditorCanvas.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB,EAAE,+BAA+B;IACnD,UAAU,EAAE,qBAAqB;AACrC;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,wCAAwC;IACxC,+EAA+E;IAC/E,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,WAAW,EAAE,sBAAsB;IACnC,sBAAsB,EAAE,yCAAyC;IACjE,gBAAgB,EAAE,yCAAyC;AAC/D;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,UAAU,EAAE,oCAAoC;IAChD,WAAW,EAAE,qCAAqC;IAClD,kBAAkB,EAAE,+CAA+C;IACnE,oBAAoB,EAAE,2CAA2C;IACjE,WAAW,EAAE,sBAAsB;IACnC,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe,EAAE,uCAAuC;IACxD,WAAW,EAAE,sCAAsC;IACnD,uBAAuB;IACvB,YAAY,EAAE,uCAAuC;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAE,2BAA2B;AAC5C;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,YAAY,EAAE,8BAA8B;IAC5C,eAAe,EAAE,2CAA2C;IAC5D,cAAc,EAAE,+BAA+B;AACnD;;AAEA;IACI,kBAAkB,EAAE,qCAAqC;IACzD,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY,EAAE,4BAA4B;IAC1C,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB,EAAE,gDAAgD;AACzE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA,0BAA0B;AAC1B;IACI,YAAY,EAAE,8BAA8B;IAC5C,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,gBAAgB,EAAE,wBAAwB;IAC1C,iBAAiB,EAAE,4BAA4B;IAC/C,iBAAiB;IACjB,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,8CAA8C;AAClD;;AAEA,eAAe;AACf;IACI,UAAU;IACV,WAAW,EAAE,4BAA4B;IACzC,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAE,8BAA8B;IAC5C,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW,EAAE,6BAA6B;IAC1C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB,EAAE,wBAAwB;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB,EAAE,4BAA4B;AACpD;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;;;IAGI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,gBAAgB,EAAE,uBAAuB;IACzC,cAAc,EAAE,qBAAqB;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,2BAA2B;IACrC,iBAAiB,EAAE,qBAAqB;IACxC,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,iBAAiB,EAAE,4BAA4B;IAC/C,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,6CAA6C;IAC7C,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,6EAA6E;IAC7E,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,kBAAkB,EAAE,uBAAuB;IAC3C,gBAAgB;AACpB;;AAEA;IACI,aAAa,EAAE,gCAAgC;IAC/C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY,EAAE,2BAA2B;IACzC,qBAAqB,EAAE,qBAAqB;IAC5C,6BAA6B;AACjC;;AAEA;IACI,oBAAoB,EAAE,wBAAwB;IAC9C,YAAY;IACZ,qBAAqB;IACrB,mBAAmB,EAAE,4BAA4B;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,2DAA2D,EAAE,wBAAwB;IACrF,YAAY,EAAE,gBAAgB;IAC9B,kBAAkB,EAAE,qBAAqB;IACzC,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa,EAAE,8BAA8B;IAC7C,iBAAiB;IACjB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,mBAAmB,EAAE,4BAA4B;IACjD,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB,EAAE,8BAA8B;IAChD,eAAe,EAAE,qBAAqB;IACtC,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB,EAAE,4BAA4B;IACjD,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB,EAAE,mBAAmB;AAC/C;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,QAAQ,EAAE,2BAA2B;IACrC,mBAAmB,EAAE,oBAAoB;AAC7C;;AAEA;IACI,SAAO;IACP,YAAY,EAAE,qBAAqB;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB,EAAE,4BAA4B;AACrD;;AAEA,6BAA6B;AAC7B;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB,EAAE,4BAA4B;IACjD,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC,EAAE,6BAA6B;IACjE,mCAAmC;IACnC,qDAAqD;IACrD,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,qDAAqD;IACrD,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB,EAAE,wBAAwB;AAC/C;;AAEA,yBAAyB;AACzB;IACI,kBAAkB,EAAE,mBAAmB;IACvC,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,gBAAgB;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB,EAAE,4BAA4B;IACjD,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB,EAAE,4BAA4B;IACjD,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB,EAAE,wBAAwB;IAC1C,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,8CAA8C;AAClD;;AAEA,4CAA4C;AAC5C;IACI,mBAAmB,EAAE,4BAA4B;IACjD,cAAc;IACd,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;QACf,gBAAgB,EAAE,gCAAgC;QAClD,mBAAmB,EAAE,+CAA+C;IACxE;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe,EAAE,mBAAmB;QACpC,2BAA2B;QAC3B,WAAW,EAAE,wBAAwB;QACrC,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,gBAAgB,EAAE,wBAAwB;QAC1C,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe,EAAE,wBAAwB;QACzC,YAAY;IAChB;;IAEA;QACI,WAAW,EAAE,oBAAoB;IACrC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY,EAAE,oBAAoB;QAClC,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,YAAY,EAAE,oBAAoB;QAClC,eAAe,EAAE,0BAA0B;IAC/C;;IAEA;QACI,iBAAiB,EAAE,oBAAoB;IAC3C;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB,EAAE,oBAAoB;IAC3C;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,0DAA0D,EAAE,wBAAwB;QACpF,WAAW;IACf;;IAEA;QACI,YAAY,EAAE,oBAAoB;IACtC;;IAEA;;;QAGI,gBAAgB,EAAE,oBAAoB;QACtC,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB,EAAE,wBAAwB;QAC1C,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,0DAA0D;QAC1D,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".outer-canvas-container canvas {\n    font-smooth: always;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n/* Editor wrapper */\n.editor-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n    background-color: #f3f4f6;\n    min-height: 100vh;\n    position: relative; /* Establish stacking context */\n    z-index: 1; /* Baseline z-index */\n}\n\n/* Toolbar */\n.toolbar {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0.75rem;\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    transition: max-height 0.3s ease, background-color 0.3s ease, opacity 0.3s ease;\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    width: 100%; /* Ensure full width */\n    box-sizing: border-box; /* Include padding in width calculation */\n    overflow-x: auto; /* Allow horizontal scrolling if needed */\n}\n\n.toolbar.popup-open {\n    background-color: #f3f4f6; /* Neutral background */\n    opacity: 0; /* Visually indicate it's disabled */\n    z-index: 10; /* Lower z-index when popup is open */\n    position: absolute; /* Change to absolute to break sticky context */\n    pointer-events: none; /* Disable interaction when popup is open */\n    width: 100%; /* Ensure full width */\n    top: 0;\n}\n\n.toolbar-collapsed {\n    max-height: 4.5rem;\n}\n\n.sticky {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.tools-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap; /* Allow wrapping to prevent overflow */\n    gap: 0.5rem; /* Reduced gap for better mobile fit */\n    justify-content: center;\n    min-width: 0; /* Prevent overflow in flex container */\n}\n\n.font-tools {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem; /* Reduced gap for mobile */\n}\n\n.tools-group:not(:last-child) {\n    border-bottom: 1px solid #e5e7eb;\n    padding-bottom: 0.5rem;\n}\n\n.tool-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.25rem;\n    height: 56px; /* Reduced height for mobile */\n    min-width: 48px; /* Ensure minimum width for touch targets */\n    flex-shrink: 0; /* Prevent shrinking too much */\n}\n\n.tool-label {\n    font-size: 0.65rem; /* Slightly smaller font for mobile */\n    color: #6b7280;\n    margin-top: 2px;\n}\n\n.tool-button {\n    height: 32px; /* Reduced size for mobile */\n    width: 32px;\n    padding: 0.3rem;\n    border: 1px solid #e5e7eb;\n    background: white;\n    border-radius: 0.375rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.toolbar.popup-open .tool-button {\n    background: #f3f4f6; /* Match toolbar background when popup is open */\n}\n\n.tool-button:hover {\n    background-color: #f3f4f6;\n}\n\n.tool-button.active {\n    background-color: #e5e7eb;\n}\n\n.tool-button.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Editing mode toggle button styles */\n.mode-toggle {\n    margin-right: 6px;\n}\n\n.mode-button {\n    border: 2px solid;\n    border-color: #e5e7eb;\n    transition: all 0.2s ease;\n}\n\n.mode-button.mode-active {\n    background-color: #4f46e5;\n    color: white;\n    border-color: #4f46e5;\n}\n\n.mode-button.mode-active:hover {\n    background-color: #4338ca;\n    border-color: #4338ca;\n}\n\n.mode-button:not(.mode-active):hover {\n    border-color: #d1d5db;\n    background-color: #f9fafb;\n}\n\n/* Canvas container */\n.outer-canvas-container {\n    display: flex;\n    background-color: #f3f4f6;\n    border-radius: 0.5rem;\n    overflow: auto;\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    margin-top: 1rem;\n    z-index: 1;\n}\n\n.outer-canvas-container.view-mode {\n    cursor: default;\n}\n\n.outer-canvas-container.view-mode canvas {\n    cursor: default;\n}\n\n/* New responsive canvas styles */\n.canvas-container {\n    border: 5px solid #2DAA9E;\n    border-radius: 2px;\n    max-width: 100%;\n    overflow: auto;\n}\n\ncanvas {\n    max-width: 100%;\n    height: auto !important;\n}\n\n/* Tool select and color */\n.tool-select {\n    height: 32px; /* Reduced height for mobile */\n    padding: 0.2rem 0.5rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    outline: none;\n    min-width: 100px; /* Adjusted for mobile */\n    font-size: 0.9rem; /* Smaller font for mobile */\n    background: white;\n    color: #374151;\n    transition: border-color 0.3s ease;\n}\n\n.tool-select:focus {\n    border-color: #2DAA9E;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);\n}\n\n/* Tool color */\n.tool-color {\n    padding: 0;\n    width: 32px; /* Reduced size for mobile */\n    height: 32px;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    cursor: pointer;\n}\n\n/* Font size control */\n.font-size-control {\n    display: flex;\n    align-items: center;\n    height: 32px; /* Reduced height for mobile */\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    overflow: hidden;\n}\n\n.font-size-control .tool-button {\n    height: 100%;\n    width: 24px; /* Reduced width for mobile */\n    border: none;\n    border-radius: 0;\n}\n\n.font-size-display {\n    min-width: 1.8rem; /* Adjusted for mobile */\n    text-align: center;\n    padding: 0 0.3rem;\n    font-size: 0.85rem; /* Smaller font for mobile */\n}\n\n/* Hidden elements */\n.hidden {\n    display: none;\n}\n\n/* Context menu */\n.context-menu {\n    position: absolute;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.context-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    width: 100%;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    white-space: nowrap;\n}\n\n.context-menu-item:hover {\n    background-color: #f3f4f6;\n}\n\n/* Dropdown menus */\n.shapes-dropdown,\n.download-dropdown,\n.layers-dropdown {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    z-index: 200;\n    min-width: 160px; /* Reduced for mobile */\n    padding: 6px 0; /* Adjusted padding */\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 6px; /* Reduced gap for mobile */\n    padding: 6px 12px; /* Adjusted padding */\n    width: 100%;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    font-size: 0.9rem; /* Smaller font for mobile */\n    color: #374151;\n    white-space: nowrap;\n}\n\n.dropdown-item:hover {\n    background: #f3f4f6;\n}\n\n/* Utility classes */\n.relative {\n    position: relative;\n}\n\n.text-red-500 {\n    color: #ef4444;\n}\n\n.ml-1 {\n    margin-left: 0.25rem;\n}\n\n/* Loading fonts */\n.loading-fonts {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    gap: 1rem;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-radius: 50%;\n    border-top-color: #2DAA9E;\n    animation: spin 1s linear infinite;\n}\n\n/* Popup styles */\n.popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100000;\n    pointer-events: auto;\n}\n\n.popup-content {\n    background-color: var(--white);\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    max-width: 700px;\n    width: 95%;\n    max-height: 80vh;\n    overflow-y: auto;\n    z-index: 100001;\n    pointer-events: auto;\n}\n\n.popup-header {\n    padding: 1rem 1.5rem;\n    background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);\n    color: var(--white);\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n}\n\n.popup-header h3 {\n    margin: 0;\n    font-size: 1.25rem; /* Reduced for mobile */\n    font-weight: 600;\n}\n\n.popup-body {\n    padding: 1rem; /* Adjusted padding for mobile */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.popup-footer {\n    display: flex;\n    justify-content: center;\n    gap: 0.75rem; /* Reduced gap for mobile */\n    padding: 0.75rem 1rem; /* Adjusted padding */\n    border-top: 1px solid #e5e7eb;\n}\n\n.popup-button {\n    padding: 0.5rem 1rem; /* Adjusted for mobile */\n    border: none;\n    border-radius: 0.5rem;\n    font-size: 0.875rem; /* Smaller font for mobile */\n    min-width: 100px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.popup-button-primary {\n    background-color: var(--secondary);\n    color: var(--white);\n}\n\n.popup-button-primary:hover {\n    background-color: #45b369;\n    transform: translateY(-2px);\n}\n\n.popup-button-primary:disabled {\n    background-color: #6b7280;\n    cursor: not-allowed;\n}\n\n.popup-button-secondary {\n    background-color: #e5e7eb;\n    color: #374151;\n}\n\n.popup-button-secondary:hover {\n    background-color: #d1d5db;\n    transform: translateY(-2px);\n}\n\n.image-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Adjusted for mobile */\n    gap: 0.75rem; /* Reduced gap */\n    padding: 0.75rem 0; /* Adjusted padding */\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.image-option-wrapper {\n    position: relative;\n    overflow: hidden;\n    border-radius: 0.5rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease;\n}\n\n.image-option {\n    width: 100%;\n    height: 100px; /* Reduced height for mobile */\n    object-fit: cover;\n    cursor: pointer;\n    border: 2px solid transparent;\n}\n\n.image-option-wrapper:hover .image-option {\n    border-color: var(--primary);\n}\n\n.image-option-wrapper:hover {\n    transform: scale(1.05);\n}\n\n.no-images,\n.loading {\n    text-align: center;\n    color: #6b7280;\n    font-size: 0.875rem; /* Smaller font for mobile */\n    padding: 0.75rem;\n}\n\n.prompt-textarea {\n    width: 100%;\n    min-height: 80px; /* Reduced height for mobile */\n    padding: 0.5rem; /* Adjusted padding */\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    font-size: 0.875rem; /* Smaller font for mobile */\n    resize: vertical;\n    transition: border-color 0.3s ease;\n    margin-bottom: 0.75rem; /* Reduced margin */\n}\n\n.prompt-textarea:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);\n}\n\n.search-input-container {\n    display: flex;\n    gap: 8px; /* Reduced gap for mobile */\n    margin-bottom: 15px; /* Adjusted margin */\n}\n\n.search-input {\n    flex: 1;\n    padding: 6px; /* Adjusted padding */\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 0.875rem; /* Smaller font for mobile */\n}\n\n/* Advanced Options Section */\n.advanced-options {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.advanced-options-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    padding: 0.5rem 0;\n    color: var(--light);\n    font-size: 0.875rem; /* Smaller font for mobile */\n    font-weight: 500;\n}\n\n.advanced-options-header:hover {\n    /* Changed color to hide the button on the frontend */\n    color: var(--light);\n}\n\n.triangle-icon {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent; /* Adjusted size for mobile */\n    border-right: 5px solid transparent;\n    /* Changed color to hide the button on the frontend */\n    border-top: 5px solid var(--light);\n    transition: transform 0.3s ease;\n}\n\n.advanced-options-header:hover .triangle-icon {\n    /* Changed color to hide the button on the frontend */\n    border-top-color: var(--light);\n}\n\n.advanced-options-header.open .triangle-icon {\n    transform: rotate(180deg);\n    /* Changed color to hide the button on the frontend */\n    border-top-color: #2DAA9E;\n}\n\n.advanced-options-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n}\n\n.advanced-options-content.open {\n    max-height: 180px; /* Adjusted for mobile */\n}\n\n/* GenAI Model Selector */\n.genai-model-selector {\n    margin-top: 0.5rem; /* Reduced margin */\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem; /* Reduced gap */\n    width: 100%;\n}\n\n.genai-model-selector label {\n    font-size: 0.875rem; /* Smaller font for mobile */\n    color: #374151;\n    font-weight: 500;\n    align-self: flex-start;\n}\n\n.genai-model-selector .tool-select {\n    width: 100%;\n    font-size: 0.875rem; /* Smaller font for mobile */\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    background: white;\n    transition: border-color 0.3s ease;\n    min-width: 200px; /* Adjusted for mobile */\n    white-space: nowrap;\n}\n\n.genai-model-selector .tool-select:focus {\n    border-color: #2DAA9E;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(102, 210, 206, 0.1);\n}\n\n/* Ensure select options have visible text */\n.genai-model-selector .tool-select option {\n    font-size: 0.875rem; /* Smaller font for mobile */\n    color: #374151;\n    white-space: nowrap;\n}\n\n/* Animation */\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .toolbar {\n        padding: 0.5rem;\n        overflow-x: auto; /* Enable horizontal scrolling */\n        white-space: nowrap; /* Prevent wrapping unless explicitly allowed */\n    }\n\n    .toolbar-collapsed {\n        max-height: 4rem;\n    }\n\n    .tools-group {\n        flex-wrap: wrap; /* Allow wrapping */\n        justify-content: flex-start;\n        gap: 0.4rem; /* Further reduced gap */\n        min-width: 0;\n    }\n\n    .tool-select {\n        width: 100%;\n        max-width: 160px; /* Adjusted for mobile */\n        min-width: 90px;\n        font-size: 0.85rem;\n    }\n\n    .font-size-control {\n        width: 100%;\n        max-width: 90px; /* Adjusted for mobile */\n        height: 30px;\n    }\n\n    .font-size-control .tool-button {\n        width: 22px; /* Further reduced */\n    }\n\n    .font-size-display {\n        font-size: 0.8rem;\n    }\n\n    .tool-button {\n        height: 30px; /* Further reduced */\n        width: 30px;\n        padding: 0.25rem;\n    }\n\n    .tool-item {\n        height: 52px; /* Further reduced */\n        min-width: 44px; /* Adjusted touch target */\n    }\n\n    .tool-label {\n        font-size: 0.6rem; /* Further reduced */\n    }\n\n    .outer-canvas-container {\n        width: 100%;\n        overflow-x: auto;\n    }\n\n    canvas#canvas {\n        transform-origin: top left;\n        margin: 0 auto;\n    }\n\n    .popup-content {\n        width: 95%;\n        max-height: 90vh;\n    }\n\n    .popup-header h3 {\n        font-size: 1.1rem; /* Further reduced */\n    }\n\n    .popup-button {\n        padding: 0.4rem 0.8rem;\n        font-size: 0.8rem;\n        min-width: 90px;\n    }\n\n    .image-grid {\n        grid-template-columns: repeat(auto-fit, minmax(90px, 1fr)); /* Adjusted for mobile */\n        gap: 0.5rem;\n    }\n\n    .image-option {\n        height: 90px; /* Further reduced */\n    }\n\n    .shapes-dropdown,\n    .download-dropdown,\n    .layers-dropdown {\n        min-width: 140px; /* Further reduced */\n        padding: 4px 0;\n    }\n\n    .dropdown-item {\n        padding: 5px 10px;\n        font-size: 0.85rem;\n    }\n\n    .genai-model-selector .tool-select {\n        min-width: 180px; /* Adjusted for mobile */\n        font-size: 0.85rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .toolbar {\n        padding: 0.4rem;\n    }\n\n    .tools-group {\n        gap: 0.3rem;\n    }\n\n    .tool-item {\n        height: 48px;\n        min-width: 40px;\n    }\n\n    .tool-button {\n        height: 28px;\n        width: 28px;\n        padding: 0.2rem;\n    }\n\n    .tool-label {\n        font-size: 0.55rem;\n    }\n\n    .tool-select {\n        max-width: 140px;\n        font-size: 0.8rem;\n    }\n\n    .font-size-control {\n        max-width: 80px;\n        height: 28px;\n    }\n\n    .font-size-control .tool-button {\n        width: 20px;\n    }\n\n    .font-size-display {\n        font-size: 0.75rem;\n    }\n\n    .popup-header h3 {\n        font-size: 1rem;\n    }\n\n    .popup-button {\n        padding: 0.3rem 0.7rem;\n        font-size: 0.75rem;\n        min-width: 80px;\n    }\n\n    .image-grid {\n        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n        gap: 0.4rem;\n    }\n\n    .image-option {\n        height: 80px;\n    }\n\n    .prompt-textarea {\n        min-height: 70px;\n        font-size: 0.8rem;\n    }\n\n    .genai-model-selector .tool-select {\n        min-width: 160px;\n        font-size: 0.8rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
